import { faTvRetro } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, MenuProps, message } from "antd";
import React from "react";
import Helper from "../../Helper";
import { CommandCenterView } from "../../models/CommandCenterView";
import PlotAPI from "../../plotAPI";

type CommandCenterButtonProps = {
    project?: any;
};

const CommandCenterButton: React.FC<CommandCenterButtonProps> = ({ project }) => {
    const [commandCenterViews, setCommandCenterViews] = React.useState<CommandCenterView[]>([]);
    const fetchViews = async () => {
        const views = await PlotAPI.getCommandCenterViews(project);
        setCommandCenterViews(views.map((view: any) => CommandCenterView.fromApiObject(view, project.timezone)));
    };
    React.useEffect(() => {
        fetchViews();
    }, [project]);

    const menuItems: MenuProps["items"] = commandCenterViews.map((view: CommandCenterView) => ({
        label: view.name,
        key: view.id,
    }));

    const menuOptionClick: MenuProps["onClick"] = ({ key }) => {
        const selectedView = commandCenterViews.find((view) => view.id.toString() === key);
        if (!selectedView) return;
        const url = `${Helper.baseUrlAltSubdomain("app")}/jobsite_command?view=${key}`;

        window.open(url, "_blank");
    };

    return (
        <Dropdown menu={{ items: menuItems, onClick: menuOptionClick }}>
            <button
                id="command-center-button"
                className="plot-button dark:border-plot-slate! rounded-md! "
                onClick={(e) => {
                    e.preventDefault();
                    message.info("Select a Jobsite Command view from the dropdown menu.");
                }}
                type="button"
            >
                <FontAwesomeIcon icon={faTvRetro} className="text-plot-white dark:text-plot-slate" />
                <span className="ml-2 text-plot-white dark:text-plot-slate">{"Jobsite Command"}</span>
            </button>
        </Dropdown>
    );
};

export default CommandCenterButton;
